import { Dispatch } from 'redux';
import Fetch from '../../api/apiConfig/apiConfig';
import { updateRetailerMetaRequest } from '../updateRetailerMetaAction';
import { IRetailerDetails } from '../../types';

export const GET_RETAILER_SETTINGS_REQUEST = 'GET_RETAILER_SETTINGS_REQUEST';
export const GET_RETAILER_SETTINGS_RESPONSE = 'GET_RETAILER_SETTINGS_RESPONSE';
export const GET_RETAILER_SETTINGS_ERROR = 'GET_RETAILER_SETTINGS_ERROR';

export const CREATE_RETAILER_REQUEST = 'CREATE_RETAILER_REQUEST';
export const CREATE_RETAILER_RESPONSE = 'CREATE_RETAILER_RESPONSE';
export const CREATE_RETAILER_ERROR = 'CREATE_RETAILER_ERROR';

export const SET_RETAILER_SETTINGS_DATA = 'SET_RETAILER_SETTINGS_DATA';

export const updateRetailerSettingsRequest = (
  retailer: IRetailerDetails,
  onSuccess: () => void,
  onFailure: (error?: string) => void,
): any => {
  return updateRetailerMetaRequest(
    { retailers: [retailer] },
    onSuccess,
    onFailure,
  );
};

export interface ICreateRetailerRequest {
  RetailerName: string;
  Meta: { [key: string]: string };
  ProductCatalogue: string;
  DocumentCatalogue: string;
  ProductCatalogueType: string;
}

const createRetailerApi = async (retailerData: ICreateRetailerRequest) => {
  const axios = await Fetch();
  return axios.post('supplychain/createretailer', retailerData);
};

export const createRetailerRequest = (
  retailerData: ICreateRetailerRequest,
  onSuccess: () => void,
  onFailure: (error?: string) => void,
): (dispatch: Dispatch) => Promise<any> => {
  return async (dispatch: Dispatch) => {
    dispatch({
      type: CREATE_RETAILER_REQUEST,
    });

    try {
      const response = await createRetailerApi(retailerData);

      if (response.status === 200) {
        dispatch({
          type: CREATE_RETAILER_RESPONSE,
          response: response.data,
        });
        onSuccess();
      } else {
        onCreateError(dispatch);
        onFailure('Failed to create retailer');
      }
    } catch (error) {
      console.log(error);
      onFailure('Failed to create retailer');
      onCreateError(dispatch);
    }
  };
};

const onCreateError = (dispatch: Dispatch) => dispatch({
  type: CREATE_RETAILER_ERROR,
});

export const setRetailerSettingsData = (retailerData: IRetailerDetails) => {
  return {
    type: SET_RETAILER_SETTINGS_DATA,
    response: retailerData,
  };
};
